import { Search } from "@mui/icons-material";
import { FormControlLabel, Input, MenuItem, Select, FormControl, InputLabel, TextField, InputAdornment } from "@mui/material";
import { WorkflowSearchCriteria } from "model/WorkflowSearchCriteria";
import "style/workflow.scss";

interface WorkflowToolbarProps {
    criterias: WorkflowSearchCriteria;
    onChange: any;
}

const workflowStatuses = [
    { id: null, label: "Tous" },
    { id: 0, label: "Initialisé" },
    { id: 1, label: "En cours" },
    { id: 2, label: "Terminé" },
    { id: 3, label: "Échec" }
];

const workflowTypes = [
    { id: null, label: "Tous" },
    { id: 0, label: "Création société" },
    { id: 1, label: "Copie environnement" },
    { id: 2, label: "Intégration site" }
];

export function WorkflowToolbar(props:WorkflowToolbarProps) {

    return (
        <div className="workflowTollbarContainer">
            <TextField
                label="Recherche"
                variant="outlined"
                size="small"
                fullWidth
                value={props.criterias.searchText}
                onChange={(e) => props.onChange("searchText", e.target.value)}
                InputProps={{
                    startAdornment: (
                        <InputAdornment position="start">
                            <Search />
                        </InputAdornment>
                    ),
                }}
                sx={{ marginBottom: "10px" }}
            />
            
            <FormControl fullWidth size="small" sx={{ marginBottom: "10px" }}>
                <InputLabel>Statut</InputLabel>
                <Select
                    value={props.criterias.statusId !== null && props.criterias.statusId !== undefined ? String(props.criterias.statusId) : ""}
                    label="Statut"
                    onChange={(e) => props.onChange("statusId", e.target.value === "" ? null : Number(e.target.value))}
                >
                    {workflowStatuses.map((status) => (
                        <MenuItem key={status.label} value={status.id !== null && status.id !== undefined ? String(status.id) : ""}>
                            {status.label}
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>
            
            <FormControl fullWidth size="small" sx={{ marginBottom: "10px" }}>
                <InputLabel>Type</InputLabel>
                <Select
                    value={props.criterias.workflowTypeId !== null && props.criterias.workflowTypeId !== undefined ? String(props.criterias.workflowTypeId) : ""}
                    label="Type"
                    onChange={(e) => props.onChange("workflowTypeId", e.target.value === "" ? null : Number(e.target.value))}
                >
                    {workflowTypes.map((type) => (
                        <MenuItem key={type.label} value={type.id !== null && type.id !== undefined ? String(type.id) : ""}>
                            {type.label}
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>
        </div>
    );
}